import { Grid } from "@mui/material";
import CreateExternalIntegration from "./ExternalIntegrationActions/CreateExternalIntegration";

const ExternalIntegrationActions = ({
  loading,
  error,
  createIntegration,
  sellers,
}) => {
  return (
    <Grid container>
      <CreateExternalIntegration
        sellers={sellers}
        loading={loading}
        error={error}
        createIntegration={createIntegration}
      />
    </Grid>
  );
};

export default ExternalIntegrationActions;
